import './Select-e7e27ea3.css';

var classes = {"Select":"prc-Select-Select-F7Flx","TextInputWrapper":"prc-Select-TextInputWrapper-eBxmL","Disabled":"prc-Select-Disabled-EtgGW","ArrowIndicator":"prc-Select-ArrowIndicator-vtddB"};

export { classes as default };
